import RegistryModule from '../components/RegistryModule';

export default function ModuleContainer({ platform, moduleName }: { platform: string, moduleName: string }) {
  return (
    <div>
      <RegistryModule platform={platform} moduleName={moduleName} />
    </div>
  );
}
